import { API_BASE_URL, apiBase } from './apiConfig';
import { createHttpAdapter, withFallback } from './httpAdapter';
import { createLocalAdapter } from './localAdapter';
import type { PersistencePort } from './types';

export type { PersistencePort } from './types';
export { PersistenceError } from './types';

/**
 * One place decides where params live. With no API configured the app is fully
 * local; point VITE_API_BASE_URL at the service and it becomes the source of
 * truth, with localStorage as the safety net.
 *
 * The net is narrower than "writes to both": `save` falls back to localStorage
 * only when the API call fails, while `flush` writes to both unconditionally.
 * That is sufficient because every write carries complete params rather than a
 * delta, so whichever store was written last holds a loadable scenario.
 */
export function createPersistence(): PersistencePort {
  const local = createLocalAdapter();
  if (!API_BASE_URL) return local;
  return withFallback(createHttpAdapter(apiBase()), local);
}

export const persistence = createPersistence();
